import { Components, Theme } from '@mui/material';

type PopupComponentOverrides = Pick<
  Components<Theme>,
  | 'MuiDialog'
  | 'MuiDialogActions'
  | 'MuiDialogContent'
  | 'MuiDialogContentText'
  | 'MuiDialogTitle'
  | 'MuiDrawer'
  | 'MuiModal'
>;

export const popupComponentOverrides: PopupComponentOverrides = {
  // TODO Stop restyling MUI components and wrap them in our own components
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: '2rem',
      },
    },
    defaultProps: {
      PaperProps: { onClick: (e: MouseEvent) => e.stopPropagation() },
    },
  },
  // TODO Stop restyling MUI components and wrap them in our own components
  MuiDialogTitle: {
    defaultProps: {
      textAlign: 'center',
    },
  },
  MuiDrawer: {
    defaultProps: {
      PaperProps: { onClick: (e: MouseEvent) => e.stopPropagation() },
    },
  },
  MuiModal: {
    defaultProps: {
      onClick: e => e.stopPropagation(),
    },
  },
};
